import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useEffect } from 'react';
import SignupForm from '../components/auth/SignupForm';

const SignupPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    // Redirect if already logged in
    if (user) {
      navigate('/creator');
    }
  }, [user, navigate]);

  const handleSignupSuccess = () => {
    navigate('/creator');
  };

  return <SignupForm onSuccess={handleSignupSuccess} />;
};

export default SignupPage;